import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './delete-goal.style';

export type DeleteGoalMessageProps = {
  name: string;
  isProject?: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

export const DeleteGoalMessage: React.FC<DeleteGoalMessageProps> = ({
  name,
  isProject,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Styled.Header>
        <Typography variant="h5" component="h1">
          {t(
            isProject
              ? 'forms.delete-goal.message.title-project'
              : 'forms.delete-goal.message.title',
          )}
        </Typography>
        <Typography variant="body2">
          {t('forms.delete-goal.message.description.1')}
          <Styled.GoalName>{name}</Styled.GoalName>
          {t('forms.delete-goal.message.description.2')}
        </Typography>
        <Typography variant="body2">
          {t(
            isProject
              ? 'forms.delete-goal.message.warning-project'
              : 'forms.delete-goal.message.warning',
          )}
        </Typography>
      </Styled.Header>

      <Styled.Interactions>
        <Button
          variant={Variants.Contained}
          size={Sizes.Medium}
          color={Colors.TextPrimary}
          onClick={onCancel}
        >
          {t('forms.delete-goal.message.buttons.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} color={Colors.Error} onClick={onSubmit}>
          {t('forms.delete-goal.message.buttons.submit.label')}
        </Button>
      </Styled.Interactions>
    </>
  );
};
